module.exports = __webpack_public_path__ + "img/nither.ed76446b.svg";